<template>
  <div class="mobile-nav">

    <div class="mobile-menu-header">
      <router-link :to="{ name: 'home' }">
        <img class="mobile-menu-logo" src="@/assets/svgs/2024/kaernten-card_logo_white.svg" alt="Kärnten Card Logo">
      </router-link>
      <div class="mobile-menu-lang-select">
        <button @click="switchLanguage('de')" :disabled="this.$i18n.locale == 'de'" :class="{active : this.$i18n.locale == 'de'}">DE</button>
        <button @click="switchLanguage('en')" :disabled="this.$i18n.locale == 'en'" :class="{active : this.$i18n.locale == 'en'}">EN</button>
      </div>
    </div>

    <div class="mobile-nav-block mobile-top-nav">
      <router-link :to="{ name: 'home' }">
        <span class="bottom-nav-label">{{ this.$t('appName') }}</span>
      </router-link>
      <a type="button" class="btn-nav-link" :class="{active : this.$route.name == 'companies'}" @click="navigateToPage({ name: 'companies' })">
        <span class="bottom-nav-label">{{ this.$t('services') }}</span>
      </a>
      <a type="button" class="btn-nav-link" :class="{active : this.$route.name == 'buy-card'}" @click="navigateToPage({ name: 'buy-card' })">
        <span class="bottom-nav-label">{{ this.$t('buyCard') }}</span>
      </a>
    </div>
    <div class="mobile-nav-block mobile-bottom-nav">
      <router-link :to="{ name: 'my-card' }" type="button" class="btn-open-cards">
        <span class="bottom-nav-label">{{ this.$t('myCardTitle') }}</span>
        <img src="@/assets/svgs/2024/icons/my-card-white.svg" alt="mycard" class="bottom-nav-icon-inactive">
        <img src="@/assets/svgs/2024/icons/my-card.svg" alt="mycard" class="bottom-nav-icon-active">
      </router-link>
      <a type="button" class="btn-nav-link" :class="{active : this.$route.name == 'bookmarks'}" @click="navigateToPage({ name: 'bookmarks' })">
        <span class="bottom-nav-label">{{ this.$t('bookmarksTitle') }}</span>
        <img src="@/assets/svgs/2024/icons/heart-white.svg" alt="bookmarks" class="bottom-nav-icon-inactive">
        <img src="@/assets/svgs/2024/icons/heart.svg" alt="bookmarks" class="bottom-nav-icon-active">
      </a>
      <a type="button" class="btn-nav-link" :class="{active : this.$route.name == 'news'}" @click="navigateToPage({ name: 'news' })">
        <span class="bottom-nav-label">{{ this.$t('newsTitle') }}</span>
        <img src="@/assets/svgs/2024/icons/news-white.svg" alt="news" class="bottom-nav-icon-inactive">
        <img src="@/assets/svgs/2024/icons/news.svg" alt="news" class="bottom-nav-icon-active">
      </a>
      <a type="button" class="btn-nav-link btn-toggle-season" @click="toggleSeason">
        <span class="bottom-nav-label">{{ this.$store.state.season == this.seasons.winter ? $t(`seasons.sommer`) : $t(`seasons.winter`) }}</span>
        <font-awesome-icon :class="{ 'season-icon': true }" :icon="seasonIcon"/>
      </a>
    </div>


    <ul class="mobile-menu card-info-pages-menu vertical menu accordion-menu" data-accordion-menu ref="langMenu">
      <li class="mobile-menu-item card-info-page" v-for="page in pages" :key="`card-info-page-${page.id}`">
        <a @click="navigateToPage({ name: 'single-card-info', params: { uuid: page.id } })">
          {{ $t(`infopages.${page.type}`) }}
        </a>
      </li>
      <li class="mobile-menu-item card-info-page" id="menu-item-cookie-preferences">
        <!-- Below is the link that users can use to open Preferences Center to change their preferences. Do not modify the ID parameter. Place it where appropriate, style it as needed. -->
        <a href="#" id="open_preferences_center">{{ this.$t('cookieConsent.updateCookiePreferences') }}</a>
      </li>
      <li class="mobile-menu-item" v-if="installOnIOS">
        <a @click="openIosInstallationHint">
          {{ $t('installOnIos') }}
        </a>
      </li>
      <li class="mobile-menu-item version-info">
        <span class="version-info">{{ $t('appVersion') }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import foundation from '@/mixins/foundation'

export default {
  name: 'MobileNavigation',
  components: {},
  computed: {
    pages() {
      return this.$store.getters.getCurrentCardinfos.filter(page => page.type !== 'home')
    },
    newsCount() {
      return this.$store.getters.getCurrentNews.length
    },
    installOnIOS() {
      if (this.$store.state.browser && this.$store.state.browser.name && this.$store.state.browser.name == 'ios') {
        return true
      }

      return false
    },
    seasonIcon() {
      if (this.$store.state.season == this.seasons.summer) {
        return this.winterIcon
      } else {
        return this.summerIcon
      }
    }
  },
  data() {
    return {
      langs: ['de', 'en'], // 'it', 'sl'
      seasons: {
        summer: 'sommer',
        winter: 'winter'
      },
      selectedSeason: this.$store.state.season,
      winterIcon: ['fal', 'snowflake'],
      summerIcon: ['fal', 'sun'],
    }
  },
  mixins: [foundation],
  methods: {
    closeOffCanvas() {
      if (this.$parent.$refs.offCanvas !== undefined) {
        $(this.$parent.$refs.offCanvas).foundation('close')
      }

      if (this.$refs.langMenu) {
        $(this.$refs.langMenu).foundation('hideAll');
      }
    },
    navigateToPage(routerConfig) {
      this.closeOffCanvas();
      this.$router.push(routerConfig)
    },
    toggleSeason() {
      if (this.selectedSeason === this.seasons.summer) {
        this.selectedSeason = this.seasons.winter
      } else {
        this.selectedSeason = this.seasons.summer
      }

      this.$store.dispatch('updateSeason', this.selectedSeason)
      this.closeOffCanvas();
      this.$router.push({name: 'home'})
    },
    switchLanguage(lang = 'de') {
      this.$i18n.locale = lang;
      this.$store.dispatch('updateLanguage', lang);
      this.closeOffCanvas();
    },
    openIosInstallationHint() {
      this.$eBus.$emit('show-ios-installation-hint')
    },
  },
  created() {
    if (this.pages.length <= 0) {
      this.$store.dispatch('fetchCardInfos', {lang: this.$store.state.language, season: this.$store.state.season})
    }
    if (this.newsCount <= 0) {
      this.$store.dispatch('fetchNews', {lang: this.$store.state.language, season: this.$store.state.season})
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-nav {
  background: $dark-gray;

  .mobile-menu-header {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 90px);
  }

  .mobile-menu-logo {
    width: 126px;
    height: 51px;
    margin: 15px 0 0 40px;
  }

  .mobile-menu-lang-select {
    width: 50px;
    display: flex;
    flex-direction: column;

    button {
      border: 1px solid $medium-gray;
      padding: 12px;
      background: $white;
      color: $dark-gray;

      &:disabled {
        background: $light-gray;
        border: 1px solid $medium-gray;
        font-weight: bold;
        color: $dark-gray;
      }
    }
  }

  .mobile-nav-block {
    padding: 1rem 40px 0 33px;

    a, button {
      font-size: 1.2rem;
      color: white;
      padding: 15px 8px;
      width: 100%;
      border: unset;
      display: block;

      &.active {
        background-color: $light-gray;
        color: $dark-gray;
        .bottom-nav-icon-inactive {
          display: none;
        }
      }

    }

    &.mobile-bottom-nav a {
      border-bottom: 1px solid #1E2025;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:first-child {
        border-top: 1px solid #1E2025;
      }
      img, svg {
        width: 32px;
        height: auto;
      }
      &.active {
        .bottom-nav-icon-inactive {
          display: none;
        }
      }
      &:not(.active) {
        .bottom-nav-icon-active {
          display: none;
        }
      }
    }
  }



  .card-info-pages-menu {
    .mobile-menu-item {
      text-align: left;
      font-weight: 700;

      .menu-item-value {
        padding-left: .5rem;
        font-weight: normal;
      }

      a {
        padding: 1rem rem-calc(40);
        color: $white;
      }

      &.card-info-page {
        font-size: 0.875rem;
        font-weight: normal;
      }


      &.version-info {
        text-align: center;
        font-size: .85rem;
        font-weight: 100;
        color: #aaa;
        padding: 1rem;
      }
    }

    .language-item {
      padding: 0;
      font-weight: normal;

      &:last-child {
        a {
          padding-bottom: 1.5rem;
        }
      }

      a {
        padding: .5rem 1rem;
      }
    }
  }
}
</style>